import { toast } from 'react-toastify';
import { Button, Flex, Input, Tabs, Upload, Select, Spin, Checkbox, Modal } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { apiUrls } from '../../apiUrls.js';
import { useNavigate } from 'react-router-dom';
import HideSidebarInMobileMode from "../../components/HideSidebarInMobileMode.js";

const { Option } = Select;

const baseURL = apiUrls.baseURL;

const MessageList = () => {

    const [data, setData] = useState([]);
    const [messageModel, setMessageModel] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [loadingSave, setLoadingSave] = useState(false);
    const [count, setCount] = useState(0);
    const [filter, setFilter] = useState({ skip: 0, limit: 20, data: {} });
    const [dropDownUserType, setDropDownUserTypes] = useState([]);
    const [dropDownUser, setDropDownUsers] = useState([]);
    const [isShowCreateUserMessageModalVisible, setIsShowCreateUserMessageModalVisible] = useState(false);
    const [isShowCreateGroupMessageModalVisible, setIsShowCreateGroupMessageModalVisible] = useState(false);
    const permissions = useSelector((state) => state.permissions.permissions);
    const navigate = useNavigate();

    useEffect(() => {
        if (!loadingMore) setLoading(true)
        fetchData()
    }, [filter.limit, filter.skip, refreshKey])

    useEffect(() => {
        const loadNextPage = () => {
            const isNearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;
            const hasMore = data.length < count;

            if (isNearBottom && hasMore && !loading && !loadingMore) {
                setLoadingMore(true);
                setFilter((current) => ({ ...current, skip: current.skip + 1 }));
            }
        };

        window.addEventListener('scroll', loadNextPage);
        loadNextPage();
        return () => window.removeEventListener('scroll', loadNextPage);
    }, [data, count, loading, loadingMore, filter.skip]);

    const fetchData = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.post(`${baseURL}/Message/get`, filter, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;
            result.items.map(item => {
                item.key = item.id
            })
            setCount(result.count)
            setData((current) => filter.skip === 0 ? result.items : [...current, ...result.items]);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    };

    const refreshMessages = () => {
        setData([]);
        setLoading(true);
        setLoadingMore(false);
        setFilter((current) => ({ ...current, skip: 0 }));
        setRefreshKey((current) => current + 1);
    };

    const fetchUsers = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })

            var result = response.data.data;
            setDropDownUsers(result);
        } catch (error) {
        } finally {
        }
    };

    const fetchUserType = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getTypeDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })
            var result = response.data.data;
            setDropDownUserTypes(result);
        } catch (error) {
        } finally {
        }
    };

    const createUserMessage = async () => {

        if (messageModel.message == null || messageModel.message == '' || messageModel.userIds == null)
            return toast.warning('مقادیر انتخاب نشده اند', {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });

        setLoadingSave(true);
        const token = localStorage.getItem('damavandclub-token')
        try {
            await axios.post(`${baseURL}/message/sendUsersSms`, messageModel, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            toast.success('با موفقیت ارسال شد', {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            refreshMessages()
            setLoadingSave(false);
            setIsShowCreateUserMessageModalVisible(false)
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            setLoadingSave(false);
        } finally {
            setLoadingSave(false);
        }
    };

    const createGroupMessage = async () => {

        if (messageModel.message == null || messageModel.message == '' || messageModel.memberType == null)
            return toast.warning('مقادیر انتخاب نشده اند', {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });

        setLoadingSave(true);
        const token = localStorage.getItem('damavandclub-token')
        try {
            await axios.post(`${baseURL}/message/sendMemberTypeSms`, messageModel, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            toast.success('با موفقیت ارسال شد', {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            refreshMessages()
            setLoadingSave(false);
            setIsShowCreateGroupMessageModalVisible(false)
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            setLoadingSave(false);
        } finally {
            setLoadingSave(false);
        }
    };

    const showCreateUserMessageModal = async () => {
        fetchUsers()
        setMessageModel({ message: '' })
        setIsShowCreateUserMessageModalVisible(true)
    };

    const showCreateGroupMessageModal = async () => {
        fetchUserType()
        setMessageModel({ message: '' })
        setIsShowCreateGroupMessageModalVisible(true)
    };

    return (
        <div>
            <HideSidebarInMobileMode />

            <div className='row-container message-list-actions'>

                {permissions.includes('sendmessage') ? <Button className="message-list-action message-list-action-individual" onClick={() => showCreateUserMessageModal()}
                    style={{ marginTop: 10, marginBottom: 10 }}
                    type="primary"><label>ارسال پیام بصورت فردی</label></Button> : null}
                {permissions.includes('sendmessage') ? <Button className="message-list-action message-list-action-group" onClick={() => showCreateGroupMessageModal()}
                    style={{ marginTop: 10, marginBottom: 10 }}
                    type="primary"><label>ارسال پیام بصورت گروهی</label></Button> : null}
            </div>

            <div className="message-cards">
                {data.map((record) => (
                    <article key={record.id} className={`message-card ${record.sendResultCode == 0 ? 'message-card-success' : 'message-card-failed'}`}>
                        <div className="message-card-header">
                            <strong>{record.userFullName || '—'}</strong>
                            <span className="message-card-status">{record.sendResult || (record.sendResultCode == 0 ? 'ارسال موفق' : 'ارسال ناموفق')}</span>
                        </div>
                        <div className="message-card-meta">
                            <span>شماره: {record.phoneNumber || '—'}</span>
                            <span>زمان ارسال: {record.persianCreateDate || '—'}</span>
                            <span>ارسال‌کننده: {record.creatorName || '—'}</span>
                        </div>
                        <div className="message-card-body">{record.message || '—'}</div>
                    </article>
                ))}
                {loading && !loadingMore && <div className="message-list-loading"><Spin /></div>}
                {!loading && data.length === 0 && <div className="message-list-empty">موردی یافت نشد</div>}
            </div>
            {loadingMore && <div className="members-wallet-load-more"><Spin size="small" /></div>}
            <div className="members-wallet-total">
                <span>تعداد کل پیام‌ها</span>
                <strong>{count}</strong>
            </div>
            <Modal
                className="message-compose-modal"
                title={`ارسال پیام بصورت فردی`}
                open={isShowCreateUserMessageModalVisible}
                width={1000}
                closable={false}
                okButtonProps={null}
                footer={<div className='row-container'>
                    <Button onClick={() => {
                        setMessageModel({})
                        setIsShowCreateUserMessageModalVisible(false)
                    }} style={{ width: '100%' }}>بستن</Button>
                    <Button className="message-send-button" type="primary" loading={loadingSave}
                        onClick={() => createUserMessage()}
                        style={{ width: '100%' }}>{'\u0627\u0631\u0633\u0627\u0644'}</Button>
                </div>}
            >
                <Select
                    className="message-compose-select"
                    dropdownClassName="message-compose-select-dropdown"
                    style={{ width: '100%', marginTop: 10 }}
                    placeholder="انتخاب عضو(ها)"
                    mode="multiple"
                    optionFilterProp="label"
                    showSearch
                    onChange={(value) => setMessageModel({ ...messageModel, userIds: value })}
                    value={messageModel.userIds}
                >
                    {dropDownUser?.map((item) => (
                        <Option key={item.id} label={item.displayName} value={item.id}>
                            {item.displayName}
                        </Option>
                    ))}
                </Select>
                <textarea
                    placeholder='متن پیام'
                    value={messageModel.message}
                    onChange={(event) => setMessageModel({ ...messageModel, message: event.target.value })}
                    style={{ marginTop: 10, height: 200, width: '100%' }} />
            </Modal>
            <Modal
                className="message-compose-modal"
                title={`ارسال پیام بصورت گروهی`}
                open={isShowCreateGroupMessageModalVisible}
                width={1000}
                closable={false}
                okButtonProps={null}
                footer={<div className='row-container'>
                    <Button onClick={() => {
                        setMessageModel({})
                        setIsShowCreateGroupMessageModalVisible(false)
                    }} style={{ width: '100%' }}>بستن</Button>
                    <Button className="message-send-button" type="primary" loading={loadingSave}
                        onClick={() => createGroupMessage()}
                        style={{ width: '100%' }}>{'\u0627\u0631\u0633\u0627\u0644'}</Button>
                </div>}
            >

                <Select
                    className="message-compose-select"
                    dropdownClassName="message-compose-select-dropdown"
                    style={{ width: '100%', marginTop: 10 }}
                    placeholder="انتخاب نوع عضویت"
                    onChange={(value) => setMessageModel({ ...messageModel, memberType: value })}
                    value={messageModel.memberType}
                >
                    {dropDownUserType?.map((item) => (
                        <Option key={item.id} value={item.id}>
                            {item.displayName}
                        </Option>
                    ))}
                </Select>
                <textarea
                    placeholder='متن پیام'
                    value={messageModel.message}
                    onChange={(event) => setMessageModel({ ...messageModel, message: event.target.value })}
                    style={{ marginTop: 10, height: 200, width: '100%' }} />
            </Modal>
        </div>
    )
}

export default MessageList
